import React from 'react';
import config from './../../services/config.json'
import NumberFormat from 'react-number-format';
import { useContext } from 'react';
import SimpleContext from './../context/SimpleContext';

const SearchProduct = ({name, 
  price, 
  slug, 
  min, 
  max, 
  numUnit,
  unit, 
  userPrice, 
  stock, 
  category, 
  numSale,
  ulImg,
  dlImg,
  urImg,
  drImg,
  isSahmiyeh,
  mojud}) =>{

    const context = useContext(SimpleContext);

    
  let ImageEffect = 'card-img-top';
  if (stock === 0 || stock === numSale){
    ImageEffect = 'card-img-top-namojud';
  }

 return(
  <div className="searchcard" onClick={()=>context.handleShowSimpleProduct(slug, stock, numSale)}>
      <div className="card-img-top ">
        <img className={ImageEffect}  src={`${config.AndroidProductsPictures}/${slug}.jpg`} alt=""/>

        {
        stock===0 || stock===numSale?
          <img className="card-img-namojud img-thumbnail" src={`${config.DiscountImage}/${"notavailable.png"}`} alt=""/>
        :
        isSahmiyeh !== 0 ?
          <img className="card-img-namojud img-thumbnail" src={`${config.DiscountImage}/${"sahmiyeh.png"}`} alt=""/>
        :
          <img className="card-img-mini_UL img-thumbnail" src={`${config.DiscountImage}/${ulImg}`} alt=""/>
        } 

        <img className="card-img-mini_UR img-thumbnail" src={`${config.DiscountImage}/${urImg}`} alt=""/>
        <img className="card-img-mini_DL img-thumbnail" src={`${config.DiscountImage}/${dlImg}`} alt=""/>
        <img className="card-img-mini_DR img-thumbnail" src={`${config.DiscountImage}/${drImg}`} alt=""/>
      {/* <img className="card-img-namojud img-thumbnail" src={`${config.DiscountImage}/${"tamamshod.png"}`} alt=""/> */}


      </div>
      <div className="searchcard-body">
        <div className="searchcardtxt">
          <h5 className="card-text">  {name}</h5><br/>
          <p><NumberFormat value={price} displayType={'text'} thousandSeparator={true} /> ريال </p>
        </div>
      </div>
  </div>   
  );
}
export default SearchProduct;